import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ToastModule } from 'primeng/toast';
import { LoaderComponent } from './shared/loader/loader.component';
import { LoaderService } from './services/loader.service';
import { BackgroundSyncService } from './services/background-sync.service';
import { Observable } from 'rxjs';
import { CommonModule, NgIf } from '@angular/common';
import { DbService } from './services/db.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, ToastModule, LoaderComponent, NgIf, CommonModule],
  templateUrl: './app.component.html'
})
export class AppComponent implements OnInit {
  isLoading$: Observable<boolean>;
  constructor(
    private loaderService: LoaderService,
    private backgroundSyncService: BackgroundSyncService,
    private dbService: DbService,
  ) {
    this.isLoading$ = this.loaderService.loading$;
  }

  async ngOnInit(): Promise<void> {
    if (!navigator.onLine) {
      return;
    }

    await this.syncPendingUpdatesIfNeeded();
  }

  private async syncPendingUpdatesIfNeeded(): Promise<void> {
    try {
      const pendingUpdates = await this.dbService.getShipmentUpdates();
      if (pendingUpdates.length > 0) {
        await this.backgroundSyncService.syncPendingShipmentUpdates();
      }
    } catch (error) {
      console.warn('Failed to sync pending shipment updates on app init', error);
    }
  }
}
